import { renderSettingsMCQ } from "../MCQ";

const renderSettingsReOrder = (block: any) => renderSettingsMCQ(block, false);

export default renderSettingsReOrder;
